import { Line } from '@ant-design/plots'
// import Line from "@ant-design/plots/es/plots/line";

import moment from 'moment'

const LineChart = ({ Orders, Predictions, data, commulative, productProfiling, direct }) => {
  let finalData = []
  let tempDate = []
  Orders?.length > 0 &&
    // eslint-disable-next-line
    Orders?.map((order) => {
      const index = tempDate.indexOf(order.date)
      if (index === -1) {
        tempDate.push(order.date)
        finalData.push({
          date: order.date,
          amount: order.amount,
        })
      } else {
        let tempAmount = finalData[index].amount
        tempAmount = tempAmount + order.amount
        finalData[index].amount = tempAmount
      }
      // finalData.push({
      //   date: order.date,
      //   amount: order.amount,
      // });
    })

  Predictions?.length > 0 &&
    // eslint-disable-next-line
    Predictions?.map((order) => {
      finalData.push({
        date: order.date,
        amount: order.amount,
      })
    })

  let orderFinalData = []
  let Date = []
  data?.length > 0 &&
    // eslint-disable-next-line
    data?.map((dataObj) => {
      const index = Date.indexOf(dataObj.date)
      if (index === -1) {
        Date.push(dataObj.date)
        orderFinalData.push({
          date: dataObj.date,
          amount: dataObj.amount,
        })
      } else {
        let tempAmount = orderFinalData[index].amount
        tempAmount = tempAmount + dataObj.amount
        orderFinalData[index].amount = tempAmount
      }
    })

  let commulativeData = []
  commulative?.length > 0 &&
    // eslint-disable-next-line
    commulative?.map((data) => {
      commulativeData.push({
        date: moment(data.date).format('DD MMM YYYY'),
        amount: data.amount,
      })
    })

  let profilingData = direct ? productProfiling : []
  productProfiling?.length > 0 &&
    !direct &&
    // eslint-disable-next-line
    productProfiling?.map((data) => {
      profilingData.push({
        date: moment(data.saleDate).format('DD MMM YYYY'),
        count: data.count,
      })
    })

  var config = {
    data: data
      ? orderFinalData
      : commulative
      ? commulativeData
      : productProfiling
      ? profilingData
      : finalData,
    padding: 'auto',
    xField: 'date',
    yField: productProfiling ? 'count' : 'amount',
    smooth: false,
    color: '#818F6E',
    // shadowColor: "#008060",
    // colorField: "Date",
    // color: (dataObj) => {
    //   let dummy = Data.find((data) => data.Date === dataObj.Date);
    //   if (dummy.type === "pre") {
    //     return "#8A1B6A";
    //   }
    //   return "#008060";
    // },
  }
  return (
    <Line
      // loading={
      //   data || orderFinalData || commulative || finalData ? false : true
      // }
      {...config}
    />
  )
}

export default LineChart
